var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  fillRule: "evenodd",
  d: "M5.474 6.004h1.78a.466.466 0 0 0 .467-.466V3.685c0-.01 1.858-3.188 1.858-3.188H.421l1.86 3.158-.003 1.882c0 .258.209.466.466.466h1.304s-.178 1.312.395 1.885c.486.487 1.614 1.096 1.484 2.133-.129 1.036-1.134 1.15-1.668.955-.535-.195-1.085-.94-1.264-1.523-.178-.583-.663-1.182-1.1-1.117-.439.066-.341.486-.276.907.064.421.177.955.227 1.604.064.842.81 2.657 2.996 2.657s3.596-1.344 3.596-3.191c0-1.848-2.05-3.006-2.462-3.418s-.502-.713-.502-.89",
  clipRule: "evenodd"
})));
export default SvgBrand;